import type { EventPublicDTO } from "@wedding/shared-types";
import { useEventAccess } from "../hooks/useEventAccess.js";
import { PasswordForm } from "../components/auth/PasswordForm.js";
import { Spinner } from "../components/common/Spinner.js";

interface PasswordGatePageProps {
  token: string;
  children: (event: EventPublicDTO) => React.ReactNode;
}

export function PasswordGatePage({ token, children }: PasswordGatePageProps) {
  const { state, verify, verifying, verifyError } = useEventAccess(token);

  if (state.status === "loading") return <Spinner label="Chargement…" />;

  if (state.status === "not-found") {
    return (
      <div className="center-screen">
        <div className="card stack" style={{ maxWidth: 380 }}>
          <h1>Lien introuvable</h1>
          <p>Ce lien n'existe pas ou n'est plus valide. Vérifiez l'adresse ou contactez les mariés.</p>
        </div>
      </div>
    );
  }

  if (state.status === "unavailable") {
    return (
      <div className="center-screen">
        <div className="card stack" style={{ maxWidth: 380 }}>
          <h1>{state.event.name}</h1>
          <p>
            {state.event.isExpired
              ? "Ce lien a expiré."
              : "Cette galerie n'est pas disponible pour le moment."}
          </p>
        </div>
      </div>
    );
  }

  if (state.status === "needs-password") {
    return (
      <PasswordForm
        title={state.event.name}
        onSubmit={verify}
        submitting={verifying}
        error={verifyError}
      />
    );
  }

  return <>{children(state.event)}</>;
}
